import { BookCheck, Award, Image, MessageCircle, Users } from "lucide-react";
import { capitalizeWords } from "./utilities/utils";
import LessonFaq from "./LessonFaq";
import useWindowSize from "../../hooks/useWindowSize";
import MobileOnboardingOverview from "./MobileOnboardingOverview";
import { useCallback, useMemo } from "react";

const WhatYouGetWithThisCourse = ({
  lessonName,
  moduleName,
  courseModule,
  lessonIndex,
  completedLessons,
  handleUnlock,
  isModalLoading,
}) => {
  const { width } = useWindowSize();

  const getTotalLessons = useCallback(() => {
    if (!courseModule?.course_data || !Array.isArray(courseModule.course_data))
      return 0;

    return courseModule.course_data.reduce((total, module) => {
      const lessons = module?.module_content;
      return total + (Array.isArray(lessons) ? lessons.length : 0);
    }, 0);
  }, [courseModule]);

  const features = useMemo(
    () => [
      {
        icon: "https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/material-symbols-light_play-lesson-outline-rounded%20(2).webp",
        title: "Full Course Access",
        description: `Access to all ${getTotalLessons()} video lessons`,
      },
      {
        icon: "https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/fluent_certificate-32-regular.webp",
        title: "Industry-Verified Certificate",
        description: "Add to LinkedIn & resume",
      },
      {
        icon: "https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/eos-icons_project-outlined.webp",
        title: "Real world industry-relevant projects",
        description: "Practice with real scenarios",
      },
      {
        icon: "https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/humbleicons_chat.webp",
        title: "24/7 Live Doubt Solving",
        description: "Get instant help anytime you’re stuck",
      },
      {
        icon: "https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/Frame%20427322686.webp",
        title: "5 Practice Interviews",
        description: "Practice with mock interviews and get instant feedback",
      },
    ],
    [getTotalLessons],
  );

  console.log("courseModule", courseModule);
  return (
    <div className="mt-0 mb-[150px] flex h-full w-full flex-col items-start justify-start px-4 md:mt-6 md:mb-8 md:h-screen lg:px-6">
      {width > 768 && (
        <div className="w-full border-b border-white/10 pb-8 text-[24px] font-medium leading-none">
          {capitalizeWords(moduleName)}
        </div>
      )}

      <div className="mt-8 text-left text-[20px] font-bold leading-none md:text-[24px]">
        What You Get With The Course
      </div>
      <div className="mt-4 flex w-full flex-col items-start gap-3">
        {features?.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div
              key={index}
              className="flex w-full items-center gap-3 rounded-[12px]  bg-[#406AFF]/10 py-3 pl-2 pr-2 md:gap-4 md:pl-4"
            >
              <img
                alt={"ede"}
                src={feature.icon}
                className=""
                height={40}
                width={40}
              />
              <div className="flex flex-col items-start gap-1">
                <span className="text-[16px] text-base font-semibold leading-[22.4px] tracking-[0] text-white [font-family:'Inter',Helvetica]">
                  {feature.title}
                </span>
                <span className="text-[14px] font-normal leading-[20.4px] tracking-[0] text-white/50 [font-family:'Inter',Helvetica]">
                  {feature.description}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {width < 768 && (
        <div className="mt-8 w-full">
          <MobileOnboardingOverview
            courseModule={courseModule}
            lessonIndex={lessonIndex}
            completedLessons={completedLessons}
            handleUnlock={handleUnlock}
            isModalLoading={isModalLoading}
          />
        </div>
      )}

      <div className="mt-8 text-left text-[20px] font-bold leading-none md:text-[24px]">
        Frequently Asked Questions
      </div>
      <div className="mt-4 w-full">
        <LessonFaq />
      </div>
    </div>
  );
};

export default WhatYouGetWithThisCourse;
